<template>

    <div class="d-flex flex-row-reverse">
        <ul class="pagination pagination-sm" :class="parentClass">

            <li class="page-item" :class="buttonClass" v-if="pages > 1" @click="selected -= 1">
                <a class="page-link" href="#">&lt;</a>
            </li>

            <li
                v-for="(num, key) in pages"
                :key="key"
                v-if="showButton(num)"
                :disabled="(selected === num)"
                class="page-item"
                :class="buttonClass + (selected === num ? ' active' : '')"
                @click="selected = num" >

                <a class="page-link" href="#">{{ num }}</a>

            </li>

            <li class="page-item" :class="buttonClass" v-if="(pages > 1)" @click="selected += 1">
                <a class="page-link" href="#">&gt;</a>
            </li>

        </ul>
    </div>

</template>

<script>

export default {

    props: {
        list: {
            type: Array,
            default: () => [],
        },

        filteredList: {
            type: Array,
            default: () => [],
        },

        numOfItems: {
            default: 20,
            type: Number,
        },

        numOfButtons: {
            default: 4,
            type: Number,
        },

        buttonClass: {
            default: "",
            type: String,
        },

        selectedClass: {
            default: "",
            type: String,
        },

        parentClass: {
            default: "",
            type: String,
        },
    },

    data() {
        return {
            selected: 1,
        };
    },

    computed: {
        pages: function() {
            if (this.list.length) {
                return Math.ceil(this.list.length / this.numOfItems);
            }
        },

        numButtons: function() {
            if (this.numOfButtons % 2 === 0) {
                return (this.numOfButtons - 2) / 2;
            }

            return (this.numOfButtons - 3) / 2;
        },
    },

    watch: {
        list: function() {
            this.copyToFilteredList(this.list);
            this.paginate(this.selected);
        },

        selected: function() {
            this.paginate(this.selected);
        }
    },

    methods: {
        paginate() {
            if (this.selected > this.pages) this.selected = this.pages;

            if (this.selected < 1) this.selected = 1;

            let from = (this.selected - 1) * this.numOfItems;
            let to = this.selected * this.numOfItems;

            if (to >= this.list.length) to = this.list.length;

            this.copyToFilteredList(this.list.slice(from, to));
        },

        emptyFilteredList() {
            if (this.filteredList.length > 0) this.filteredList.splice(0);
        },

        copyToFilteredList(array) {
            this.emptyFilteredList();
            this.filteredList.push.apply(this.filteredList, array);
        },

        showButton(num) {
            if (num === this.selected) return true;

            if (num === 1) return true;

            if (num === this.pages) return true;

            let from = this.selected - this.numButtons;
            let to = this.selected + this.numButtons;

            if (to >= this.pages) from = from - 1 - (to - this.pages);

            if (from <= 1) to = to - from + 2;

            if (from <= num && num <= to) return true;

            return false;
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/table-components/PaginationComponent.vue